<template>
  <div class="rounded-xl bg-surface-0 dark:bg-surface-700 p-2 @sm:p-4">
    <div class="flex gap-4 justify-between">
      <p class="font-medium">{{ title }}</p>

      <span class="text-sm ma-text-secondary hidden @sm:inline">Confirm</span>
    </div>

    <div class="flex flex-wrap gap-2 @sm:gap-4 items-center mt-4">
      <AppButton
        v-for="option in parsedOptions"
        :key="option"
        :label="option"
        variant="secondary"
        @click="emit('action', option)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  options: string[];
  type: "confirmation" | "selection";
  title: string;
}>();
const emit = defineEmits<{
  action: [string];
}>();

const parsedOptions = computed(() => {
  if (props.type === "confirmation") {
    return ["Yes", "No"];
  } else {
    return props.options;
  }
});
</script>
